// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-label {
    opacity: 0;
  }
  
  div:hover > .tooltip-label {
    opacity: 1;
  }`, "",{"version":3,"sources":["webpack://./src/components/common/Actions/shareButton.css"],"names":[],"mappings":"AAAA;IACI,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ","sourcesContent":[".tooltip-label {\n    opacity: 0;\n  }\n  \n  div:hover > .tooltip-label {\n    opacity: 1;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
